import React from 'react';

export interface RadLoadingIndicatorProps {
  loading: boolean;
}

/**
 * RADファイルのメタデータ読み込み中に画面右下に表示されるローディングインジケーター
 *
 * @param loading - ローディング表示の有効/無効
 */
export function RadLoadingIndicator({ loading }: RadLoadingIndicatorProps) {
  if (!loading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '140px',
        height: '48px',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: '8px',
        padding: '12px 16px',
        color: 'white',
        fontSize: '14px',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
        fontFamily: 'Meiryo, sans-serif',
        opacity: 1,
        animation: 'fadeIn 0.3s ease-in',
        pointerEvents: 'none'
      }}
    >
      <div
        className='rad-spinner'
        style={{
          border: '2px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '50%',
          borderTop: '2px solid white',
          width: '14px',
          height: '14px',
          animation: 'spin 0.8s linear infinite'
        }}
      />
      <span>Loading...</span>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}
